import React from 'react';
import { SectionTitle, SectionSubtext, SearchRow, SearchInput, TemplateGrid, TemplateCard, TemplateHeader, TemplateDesc, TagRow, Tag, MetaRow, SmallMeta, CreateButton } from './shared';

export interface TemplatesTypeViewProps {
  onSelectTemplate: (t: 'pricing' | 'content') => void;
}

export const TemplatesTypeView: React.FC<TemplatesTypeViewProps> = ({ onSelectTemplate }) => (
  <>
    <SectionTitle style={{ marginTop: 16}}>Template Selection</SectionTitle>
    <SectionSubtext style={{ fontSize: 14, lineHeight: '20px' }}>
      Choose the type of data you’d like to retrieve. All templates can be customized and you’re only ever charged
      for the data Stackline successfully returns. Use our Data Explorer tab to explore a sample dataset of each
      Template before confirming your selection.
    </SectionSubtext>
    {/* <SearchRow>
      <SearchInput placeholder="Search templates" />
    </SearchRow> */}
    <TemplateGrid>
      <TemplateCard>
        <TemplateHeader>Pricing</TemplateHeader>
        <TemplateDesc>Monitor competitor pricing, discounts, and price changes in real-time.</TemplateDesc>
        <TagRow>
          <Tag>Price Monitoring</Tag>
          <Tag>First-Mover Retailer</Tag>
        </TagRow>
        <MetaRow>
          <SmallMeta>1 credit / item</SmallMeta>
          <CreateButton onClick={() => onSelectTemplate('pricing')}>Create</CreateButton>
        </MetaRow>
      </TemplateCard>

      <TemplateCard>
        <TemplateHeader>Content</TemplateHeader>
        <TemplateDesc>Extract product descriptions, titles, images, and specifications.</TemplateDesc>
        <TagRow>
          <Tag>Content Quality</Tag>
          <Tag>Image Quality</Tag>
          <Tag>Sentiment</Tag>
        </TagRow>
        <MetaRow>
          <SmallMeta>More details on the way</SmallMeta>
          <span />
        </MetaRow>
      </TemplateCard>
      <TemplateCard>
          <TemplateHeader>Reviews</TemplateHeader>
          <TemplateDesc>Extract product reviews, ratings, and customer feedback across retailers.</TemplateDesc>
          <TagRow>
            <Tag>Customer Insights</Tag>
            <Tag>Sentiment</Tag>
          </TagRow>
          <MetaRow>
            <SmallMeta>More details on the way</SmallMeta>
            <span />
          </MetaRow>
        </TemplateCard>

      <TemplateCard>
        <TemplateHeader>Availability</TemplateHeader>
        <TemplateDesc>Track product availability and inventory levels across multiple retailers.</TemplateDesc>
        <TagRow>
          <Tag>Inventory</Tag>
          <Tag>Geo-Level In Stock</Tag>
        </TagRow>
        <MetaRow>
          <SmallMeta>More details on the way</SmallMeta>
          <span />
        </MetaRow>
      </TemplateCard>

      <TemplateCard>
        <TemplateHeader>Rank</TemplateHeader>
        <TemplateDesc>Monitor product rankings and search position across categories.</TemplateDesc>
        <TagRow>
          <Tag>SEO</Tag>
          <Tag>Share of Shelf</Tag>
        </TagRow>
        <MetaRow>
          <SmallMeta>More details on the way</SmallMeta>
          <span />
        </MetaRow>
      </TemplateCard>

      <TemplateCard>
        <TemplateHeader>Promotions</TemplateHeader>
        <TemplateDesc>Track promotional campaigns, deals, and marketing activities.</TemplateDesc>
        <TagRow>
          <Tag>Deal Type</Tag>
        </TagRow>
        <MetaRow>
          <SmallMeta>More details on the way</SmallMeta>
          <span />
        </MetaRow>
      </TemplateCard>

      <TemplateCard>
        <TemplateHeader>Buy Box</TemplateHeader>
        <TemplateDesc>Monitor buy box ownership and seller competition on marketplaces.</TemplateDesc>
        <TagRow>
          <Tag>Buy Box Price</Tag>
          <Tag>Sellers</Tag>
        </TagRow>
        <MetaRow>
          <SmallMeta>More details on the way</SmallMeta>
          <span />
        </MetaRow>
      </TemplateCard>

      <TemplateCard>
        <TemplateHeader>LLM</TemplateHeader>
        <TemplateDesc>AI-powered insights and analysis of product data and trends.</TemplateDesc>
        <TagRow>
          <Tag>AI Share of Shelf</Tag>
          <Tag>Ad Sentiment</Tag>
        </TagRow>
        <MetaRow>
          <SmallMeta>More details on the way</SmallMeta>
          <span />
        </MetaRow>
      </TemplateCard>
      
    </TemplateGrid>
  </>
);

export default TemplatesTypeView;
